(function () {
    $(document).ready(function () {
        var accordions = $(".panel-group--accordion");

        accordions.each(function () {
            var panel = $(this).find(".panel");
            var panel_title = panel.find(".panel__title > a");

            // Collapse all panels except for 1st panel
            panel.not(":eq(0)").addClass("panel--collapsed");
            $(".panel--collapsed .panel__title > a").attr("tabindex", "-1");

            panel_title.click(function () {
                $(this).closest(".panel").toggleClass("panel--collapsed");
                if (this.hasAttribute("tabindex")) {
                    $(this).removeAttr("tabindex");
                } else {
                    $(this).attr("tabindex", "-1");
                }

                return false;
            });
        });
    });
})(this);
